import { Box, Stack, Typography } from '@mui/material'
import { TpChip } from '~/components/tp-chip'
import { TpTooltip } from '~/components'
import { useCropModalContext } from '../context/crop-modal-context'
import { CROP_TASK_TYPES } from '../constants/crop-modal-constants'

export const CropTaskChips = ({
  effectiveTaskCodes,
  effectivePhaseCodes,
  effectivePropagationCodes,
  activePropagationCode,
  cropPhaseTypes,
  onTaskToggle,
}) => {
  const { species, isCustomCrop } = useCropModalContext()

  if (!species && !isCustomCrop) return null

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 2, mb: 1 }}>
      <Typography
        variant="caption"
        sx={{ width: '100%', color: 'text.secondary', mb: 0.5 }}
      >
        Tasks to Generate:
      </Typography>

      {CROP_TASK_TYPES
        .filter(task => {
          if (isCustomCrop) return true
          const isDirectSow = effectivePropagationCodes.includes('outdoor_sow')
          if (task.directSowOnly === true) return isDirectSow
          if (task.directSowOnly === false) return !isDirectSow
          return true
        })
        .map((task) => {
          const isRequiredPhasePresent = effectivePhaseCodes?.includes(task.requiredPhase)
          const isSelected = effectiveTaskCodes?.includes(task.code) && (isRequiredPhasePresent || isCustomCrop)
          let isDisabled
          if (isCustomCrop) {
            const isDirectSow = activePropagationCode === 'outdoor_sow'
            const propagationMismatch = activePropagationCode && (
              (task.directSowOnly === true && !isDirectSow) ||
              (task.directSowOnly === false && isDirectSow)
            )
            isDisabled = !!propagationMismatch
          } else {
            isDisabled = (!species) || !isRequiredPhasePresent
          }

          let tooltipText = task.description
          if (!isRequiredPhasePresent && species) {
            const phaseType = cropPhaseTypes?.find(pt => pt.code === task.requiredPhase)
            const phaseName = phaseType?.name || task.requiredPhase
            const phaseNameFriendly = phaseName?.charAt(0).toUpperCase() + phaseName?.slice(1).toLowerCase()
            tooltipText = `This task requires the "${phaseNameFriendly}" phase - please select it above to enable this task`
          }

          return (
            <TpTooltip key={task.code} title={tooltipText} enterDelay={500} followCursor>
              <Stack>
                <TpChip
                  isSelected={isSelected}
                  label={task.name}
                  disabled={isDisabled}
                  onClick={() => onTaskToggle(task.code)}
                />
              </Stack>
            </TpTooltip>
          )
        })
      }
    </Box>
  )
}
